import { ERROR_CODE }              from '../00_assets' ;

import { API_METHOD
       , kde_api_login_response_t
       }                          from './01_api_types'
import { set_user
       , logged_user }            from './02_api_auth'
import { form_data
       , form_post }              from './03_api_connect'
import REST
     , { effect_cb }              from './04_api_rest'


class Auth extends REST
{
  constructor ( )
  {
    super( 'login', [ API_METHOD.ADD ], { credentials: false } ) ;

    const original_add = this.add! ;

    this.add = async ( opts : Object ) =>
    {
      const response = await original_add( opts ) ;

      if ( response && response.error && response.error.code === ERROR_CODE.NONE )
        {
           const data = response.data as kde_api_login_response_t ;

           set_user( data.user, data.token || '' ) ;
        }

      return response ; // this.request( response ) ;
    }
  }
}


export const API =
{
  AUTH       : new Auth( )
, CLOUDS     : new REST( 'clouds' )
, WORKGROUPS : (cloud_id: number) =>
                 new REST( `clouds/${cloud_id}/workgroups`
                         , REST.ALL_METHODS
                         , { credentials: true } )
, USERS      : (cloud_id: number, workgroup_id: number, effect?: effect_cb ) =>
                 new REST( `clouds/${cloud_id}/workgroups/${workgroup_id}/users`
                         , REST.ALL_METHODS
                         , { credentials: true
                           , effect })
, MACHINES   : (cloud_id: number, workgroup_id: number) =>
                 new REST( `clouds/${cloud_id}/workgroups/${workgroup_id}/machines`
                         , REST.ALL_METHODS
                         , { credentials: true } )
, CLIENTS    : (cloud_id: number) =>
                 new REST( `clouds/${cloud_id}/clients`
                         , REST.ALL_METHODS
                         , { credentials: true } )
, JOBS      : (cloud_id: number) =>
                 new REST( `clouds/${cloud_id}/jobs`
                         , REST.ALL_METHODS
                         , { credentials: true } )
, MKS       : (cloud_id: number) =>
                 new REST( `clouds/${cloud_id}/mks`
                         , [ API_METHOD.DEL ]
                         , { credentials: true } )

, RESET_PASSWORD:  rest_enum( 'resetPassword'    )
, JOB_STATUS:      rest_enum( 'jobStatuses'      )
, ROLES:           rest_enum( 'roles'            )
, KEY_APPLICATION: rest_enum( 'key-applications' )
, MKS_TYPES:       rest_enum( 'mks/types'        )
, MACHINE_TYPES:   rest_enum( 'machines/types'   )
, DATA_SHEET:      rest_enum( 'datasheets'       )
// , KEY_APPS:        new REST( 'keyApplications', [ API_METHOD.LIST ], { credentials: true } )

, KEY_MASTERING:  (cloud_id: number) =>
                 new REST( `clouds/${cloud_id}/mks`
                         , REST.ALL_METHODS
                         , { credentials: true } )

, JOBS_BULK: (cloud_id: number) =>
                 new REST( `clouds/${cloud_id}/jobs/bulk`
                         , [ API_METHOD.ADD ]
                         , { credentials: true } )

, create_mks: async ( data: any ) =>
  {
    const body = form_data( data )
        , user = logged_user( ).get( ) ;

    return user? 
             form_post( 'clouds/' + user.workgroup.cloud.id.toString( ) + '/mks'
                      , body
                      , { credentials: true } )
           : null ;
  }
} ;


function rest_enum ( name: string )
{
  return new REST( name, [ API_METHOD.LIST ], { credentials: true } ) ;
}